import Api from '../utilities/api';
import {
  triggerIdA
} from './apiConfig';
import TriskeleScreens from './TriskeleScreens';

export default class MasterAccess {
    static getAllUnits = () => Api.post('_Mstr_AllUnits', {
      params: [
        {
          name: 'ScrnId',
          value: TriskeleScreens.master.ScreenId
        },
        {
          name: 'TrggrId',
          value: triggerIdA
        },
        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'isVisible',
          value: '1'
        }
      ]
    });

    static getAllMeasures = () => Api.post('_Mstr_AllMeasures', {
      params: [
        {
          name: 'ScrnId',
          value: TriskeleScreens.master.ScreenId
        },
        {
          name: 'TrggrId',
          value: triggerIdA
        },
        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'isVisible',
          value: '1'
        }
      ]
    });

    static getAllProperties = () => Api.post('_Mstr_AllPropertys', {
      params: [
        {
          name: 'ScrnId',
          value: TriskeleScreens.master.ScreenId
        },
        {
          name: 'TrggrId',
          value: triggerIdA
        },
        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'CurrentVrs',
          value: '1.0.0'
        },
        {
          name: 'isVisible',
          value: '1'
        }
      ]
    })

    static getAllMeasuresCategory = () => Api.post('_Mstr_AllMeasureCtgys', {
      params: [
        {
          name: 'ScrnId',
          value: TriskeleScreens.master.ScreenId
        },
        {
          name: 'TrggrId',
          value: triggerIdA
        },
        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'isVisible',
          value: 1
        }
      ]
    })

    static getUserRightsAccess = () => Api.post('_User_UserAccess', {
      params: [
        {
          name: 'TrggrId',
          value: triggerIdA
        },
        {
          name: 'ScrnId',
          value: TriskeleScreens.master.ScreenId
        },

        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'isVisible',
          value: 1
        }
      ]
    })

    static getAppFeatures = () => Api
      .post('_Mstr_AllAppFeatures', {
        params: [
          {
            name: 'ScrnId',
            value: TriskeleScreens.master.ScreenId
          },
          {
            name: 'TrggrId',
            value: triggerIdA
          },
          {
            name: 'BuildfireID',
            value: "D"
          },
          {
            name: 'isVisible',
            value: 1
          }
        ]
      })
}
